import CrudReducer from './crudReducer';

const cr = new CrudReducer('plan');

const reducer = cr.Reducer;

export default reducer;
